import { Container as StyledContainer } from './Container.styles.js';

const Container = ({ children, padded }) => (
	<StyledContainer padded>
		{children}
	</StyledContainer>
);

export default Container;
